const LoadingIconGreen = () => {
    
    return (
        <div className="lds-ring">
            <div></div><div></div><div></div>
        </div>
    )
}

export default LoadingIconGreen;